import React from 'react'
import PageSection from 'components/PageSection'
import useTheme from 'hooks/useTheme'
import HeroSection from './components/HeroSection'
import InfoSection from './components/InfoSection'
import LicoFooter from './components/LicoFooter'
import ShowCaseSection from './components/ShowCaseSection'
import HotSection from './components/HotSection/HotSection'
/* 
import StatsSection from './components/StatsSection'
import Stat from './components/Stat' 

const HiddenPageSection = styled.div`
  display: none;

  ${({ theme }) => theme.mediaQueries.sm} {
    display: block;
  }
`

const stats = [
  { label: 'Collections', value: '10' },
  { label: 'NFTs Traded', value: '+8,000' },
  { label: 'Total Volume', value: '363,904' },
  { label: 'Market Cap', value: '$2 billion' },
]
*/

const Home: React.FC = () => {
  const { theme } = useTheme()
  return (
    <>
      <PageSection
        innerProps={{ style: { margin: '0', width: '100%', paddingTop: 0, paddingBottom: 0 } }}
        background="linear-gradient(118.51deg, #EB0057 -136.35%, #050505 9.88%, #FF5356 237.28%, #000000 348.75%);"
        index={1}
        hasCurvedDivider={false}
      >
        <HeroSection />
      </PageSection>

      <PageSection innerProps={{ style: { margin: '0', width: '100%' } }} hasCurvedDivider={false} index={2}>
        <HotSection />
      </PageSection>

      {/* <HiddenPageSection>
        <PageSection
          innerProps={{ style: { margin: '0', width: '100%' } }}
          hasCurvedDivider
          background={
            theme.isDark
              ? 'linear-gradient(90deg, #D22A82 0%, #EC5B39 100%);'
              : 'linear-gradient(180deg, #FFFFFF 22%, #D7CAEC 100%)'
          }
          index={3}
        >
          <StatsSection stats={stats} />
        </PageSection>
      </HiddenPageSection> */}

      <PageSection innerProps={{ style: { margin: '0', width: '100%' } }} index={4} hasCurvedDivider>
        <ShowCaseSection />
      </PageSection>

      <PageSection
        innerProps={{ style: { margin: '0', width: '100%' } }}
        hasCurvedDivider
        background={
          theme.isDark
            ? 'linear-gradient(90deg, #D22A82 0%, #EC5B39 100%);'
            : 'linear-gradient(180deg, #FFFFFF 22%, #D7CAEC 100%)'
        }
        index={5}
      >
        <InfoSection />
      </PageSection>

      <LicoFooter />
    </>
  )
}

export default Home
